<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formularioFormaDesembolso"  novalidate id="fFormaDesembolso" name="fFormaDesembolso">
          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>{{ 'EXCEPCIONESGMF.LBL_ESPECIE' | translate }}</label>
                <p-dropdown disableTab  id="idFormaDesembolso" name="nomFormaDesembolso" [options]="lisFormasDesembolso"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idFormaDesembolso"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fFormaDes.idFormaDesembolso.invalid && seccionInicialDirty()">
                  {{ 'EXCEPCIONESGMF.LBL_ESPECIE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>{{ 'EXCEPCIONESGMF.LBL_CRUZADO' | translate }}</label>
                <p-dropdown disableTab  id="idCruzado" name="nomCruzado" [options]="lisPrimerBeneficiariosCruzados"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idCruzado"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fFormaDes.idCruzado.invalid && seccionInicialDirty()">
                  {{ 'EXCEPCIONESGMF.LBL_CRUZADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>{{ 'EXCEPCIONESGMF.LBL_PRIMERBENEFICIARIO' | translate }}</label>
                <p-dropdown disableTab  id="idPrimerBeneficiario" name="nomPrimerBeneficiario" [options]="lisPrimerBeneficiariosCruzados"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idPrimerBeneficiario"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fFormaDes.idPrimerBeneficiario.invalid && seccionInicialDirty()">
                  {{ 'EXCEPCIONESGMF.LBL_PRIMERBENEFICIARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>{{ 'EXCEPCIONESGMF.LBL_BENEFICIARIO' | translate }}</label>
                <p-dropdown disableTab  id="idBeneficiario" name="nomBeneficiario" [options]="lisBeneficiarios"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idBeneficiario"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fFormaDes.idBeneficiario.invalid && seccionInicialDirty()">
                  {{ 'EXCEPCIONESGMF.LBL_BENEFICIARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
        </form>
      <div class="grid col-12">
        <div class="col-12 md:col-6 lg:col-6">
          <form [formGroup]="formularioPorTipoCredito"  novalidate id="fPorTipoCredito" name="fPorTipoCredito">
                <div class="div-form">
                  <p-fieldset legend="{{ 'EXCEPCIONESGMF.LBL_PORTIPOCREDITO' | translate }}" class="overflow-y-unset">
                    <div class="grid col-12 p-0">
                      <div class="col-12 md:col-12 lg:col-12">
                        <div class="div-form">
                          <label>{{ 'EXCEPCIONESGMF.LBL_PORTIPOCREDITO' | translate }}</label>
                          <p-dropdown disableTab  id="idTipoCredito" name="nomTipoCredito" [options]="lisTiposCreditos"
                                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                      optionValue="value"
                                      optionLabel="label"
                                       formControlName="idTipoCredito"
                          ></p-dropdown>
                          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fPorTipoCred.idTipoCredito.invalid">
                            {{ 'EXCEPCIONESGMF.LBL_PORTIPOCREDITO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-fieldset>
                </div>
          </form>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <form [formGroup]="formularioPorCuentaAhorros"  novalidate id="fPorCuentaAhorros" name="fPorCuentaAhorros">
                  <div class="div-form">
                    <p-fieldset  legend="{{ 'EXCEPCIONESGMF.LBL_PORCUENTADEAHORROS' | translate }}">
                      <div style="height: 62px;" class="grid">
                        <div class="col-12 md:col-12 lg:col-12">
                          <p-checkbox label="{{ 'EXCEPCIONESGMF.LBL_MANEJACUENTAAHORROSTITULAR' | translate}}" binary="true"
                                      id="idIndicadorManejaCtaAhorros"
                                      name="nomIndicadorManejaCtaAhorros"
                                      formControlName="indicadorManejaCtaAhorros"></p-checkbox>
                        </div>
                      </div>
                    </p-fieldset>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fCuentaAho.indicadorManejaCtaAhorros.invalid">
                      {{ 'EXCEPCIONESGMF.LBL_MANEJACUENTAAHORROSTITULAR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
          </form>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <a (click)="regresar(formularioFormaDesembolso.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                    type="submit" (click)="onSubmit()"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
